import { Options } from "vue-class-component";
import BaseFunction from "@/mixins/BaseFunction";

@Options({
    name: "flowable-workspace-logs-workspace",
})
export default class LogsWorkspace extends BaseFunction {

}
